import { createReducer, on, Action } from '@ngrx/store';
import {
    loadAutosentEnvelopeSuccess,
    loadAutosentEnvelopeFailure,
    autosentEnvelopeSignalReceived
} from '../actions/autosend-envelope.actions';
import { AutosendEnvelopeState } from '../state/autosend-envelope.state';

const initialState: AutosendEnvelopeState = {
    autosentEnvelope: null
};

const reducer = createReducer(
    initialState,
    on(loadAutosentEnvelopeSuccess, (_, action) => ({
        autosentEnvelope: action.envelope
    })),
    on(loadAutosentEnvelopeFailure, (_) => ({
        autosentEnvelope: null
    })),
    on(autosentEnvelopeSignalReceived, (state, action) => ({
        ...state,
        autosentEnvelope: action.envelope
    }))
);

export function autosendEnvelopeReducer(state: AutosendEnvelopeState | undefined, action: Action) {
    return reducer(state, action);
}
